import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import '../../bower_components/materialize/dist/css/materialize.min.css'
import './fonts/MyFontsWebfontsKit.css'
import './index.css'
import './disrupt.css'
import './responsive.css'
import './font-awesome.css'

let logoStyle = {
    marginTop:'10px',
    height: 40
};


// margin-top: 10px;

const Header = () => (
    <nav className="black">
        <div className="container">
            <div className="nav-wrapper">
                <a href="https://www.disrupt.university/" target="_blank" className="brand-logo">
                    <img style={logoStyle} className="" src="https://disrupt.digital/wp-content/uploads/2017/12/disrupt-logo.png" />
                </a>

                <ul id="nav-mobile" className="right hide-on-med-and-down text-uppercase">
                    {/*<li><a href="#about">About</a></li>*/}
                    <li><a href="#speakers">Speakers</a></li>
                    <li><a href="#agenda">Agenda</a></li>
                    <li><a href="#sponsors">Sponsors</a></li>
                    {/*<li><a href="#hotel">Hotels</a></li>*/}
                    <li><a className="btn orange" href="#tickets">Tickets</a></li>
                </ul>

            </div>
        </div>

    </nav>
)

const TemplateWrapper = ({ children }) => (
<div>

<Helmet
title="Disrupt Puerto Rico 2018"
meta={[
    { name: 'description', content: 'Disrupt Puerto Rico is an exciting new tech conference, being held in San Jaun, PR.' },
    { name: 'keywords', content: 'Entreprenuers, Puerto Rico, Hackathon, Tech, Mentors' },
    { name: 'og:title', content: 'Disrupt Puerto Rico 2018 Hackathon & Conference' },
    { name: 'og:type', content: 'website' },
    { name: 'og:description', content: 'Disrupt Puerto Rico is an exciting new tech conference, being held in San Jaun, PR.' },
    { name: 'og:url', content: 'http://disruptweek.com/' },


    { name: 'og:site-name', content: 'http://disruptweek.com/' }



]}
/>
<Header />
<div
style={{
    // margin: '0 auto',
    // maxWidth: 960,
    // padding: '0px 1.0875rem 1.45rem',
    // paddingTop: 0,
}}
>
{children()}
</div>
</div>
)

TemplateWrapper.propTypes = {
    children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js